import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
import {Message} from 'element-ui'
import {getToken} from '@/utils/auth' // 验权
import webSocketManager from '@/utils/webSocketLink'

const whiteList = ['/login'] // 不重定向白名单
router.beforeEach((to, from, next) => {
  NProgress.start()
  if (getToken()) {
    if (to.path === '/login') {
      next({path: '/'})
      NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else {
      if (store.getters.roles.length === 0) {
        store.dispatch('GetInfo').then(res => { // 拉取用户信息
          let menus = res.body.data.menus;
          let username = res.body.data.username;

          store.dispatch('GenerateRoutes', {menus, username}).then(() => { // 生成可访问的路由表

            router.addRoutes(store.getters.addRouters); // 动态添加可访问路由表
            
            // 如果用户已登录但WebSocket未连接，检查权限后决定是否重新连接
            if (!store.getters.websocketConnected && store.getters.hasNotificationPermission) {
              webSocketManager.createConnection().then(() => {
                store.commit('SET_WEBSOCKET_STATUS', true)
                // console.log('页面刷新后WebSocket重新连接成功')
              }).catch(error => {
                console.error('页面刷新后WebSocket重连失败:', error)
                store.commit('SET_WEBSOCKET_STATUS', false)
              })
            } else if (!store.getters.hasNotificationPermission) {
              console.log('用户无通知权限，跳过WebSocket连接')
              store.commit('SET_WEBSOCKET_STATUS', false)
            }
            
            next({...to, replace: true})
          })
        }).catch((err) => {
          store.dispatch('FedLogOut').then(() => {
            Message.error(err || 'Verification failed, please login again')
            next({path: '/'})
          })
        })
      } else {
        // 如果用户信息已存在但WebSocket未连接，检查权限后决定是否重新连接
        if (!store.getters.websocketConnected && store.getters.hasNotificationPermission) {
          webSocketManager.createConnection().then(() => {
            store.commit('SET_WEBSOCKET_STATUS', true)
            // console.log('WebSocket重新连接成功')
          }).catch(error => {
            console.error('WebSocket重连失败:', error)
            store.commit('SET_WEBSOCKET_STATUS', false)
          })
        } else if (!store.getters.hasNotificationPermission) {
          console.log('用户无通知权限，跳过WebSocket连接')
          store.commit('SET_WEBSOCKET_STATUS', false)
        }
        next()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      console.log("重新登录");
      next('/login')
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})



// WEBPACK FOOTER //
// ./src/permission.js